(() => {
  if (window.__wdCartDrawerBundleInit) return;
  window.__wdCartDrawerBundleInit = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.wd__cart-bundle-toggle');
    if (!toggle) return;

    const group = toggle.closest('.wd__cart-bundle-group');
    const panel = group?.querySelector('.wd__cart-bundle-subitems');
    const label = toggle.querySelector('.wd__cart-bundle-toggle-label');
    if (!panel || !label) return;

    const showText = label.dataset.showText;
    const hideText = label.dataset.hideText;
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      if (showText) label.textContent = showText;
    } else {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      if (hideText) label.textContent = hideText;
    }
  });

  // Keep nested children quantity in sync when the parent quantity changes.
  // Shopify only cascades removal of children when the parent is removed (qty 0).
  // Child keys are embedded on the parent row as data-wd-nested-keys (Liquid JSON).
  const CartItems = customElements.get('cart-items');
  if (!CartItems?.prototype?.updateQuantity) return;

  const originalUpdateQuantity = CartItems.prototype.updateQuantity;

  CartItems.prototype.updateQuantity = async function updateQuantity(line, quantity, name, target) {
    let qty = Number(quantity);

    // qty 0 → Shopify removes the parent and its nested children
    if (!Number.isFinite(qty) || qty === 0) {
      return originalUpdateQuantity.call(this, line, quantity, name, target);
    }

    const row =
      document.getElementById(`CartDrawer-Item-${line}`) || document.getElementById(`CartItem-${line}`);
    let keys = [];
    try {
      keys = JSON.parse(row?.dataset.wdNestedKeys || '[]');
    } catch {
      keys = [];
    }

    // No nested children → keep the theme's normal single-line change flow
    if (!Array.isArray(keys) || keys.length < 2) {
      return originalUpdateQuantity.call(this, line, quantity, name, target);
    }

    // Cap nest qty to lowest available inventory (data-wd-nested-max-qty from Liquid)
    const nestedMax = Number(row?.dataset.wdNestedMaxQty);
    if (Number.isFinite(nestedMax) && nestedMax >= 0) {
      qty = Math.min(qty, nestedMax);
    }

    try {
      // same logic as seen in CartItems.prototype.updateQuantity (except payload body)
      this.showLoader(line);

      const updates = {};
      for (const key of keys) {
        if (key) updates[key] = qty;
      }

      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );

      const parsedState = await (
        await fetch(FoxTheme.routes.cart_update_url, {
          ...FoxTheme.utils.fetchConfig(),
          body: JSON.stringify({ updates, sections }),
        })
      ).json();

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        cart: parsedState,
        target,
        line,
        name,
      });
    } catch (error) {
      console.error(error);
      return originalUpdateQuantity.call(this, line, quantity, name, target);
    }
  };
})();
